<template>
    <div
        class="relative"
        @mouseenter="hoverActive = true"
        @mouseleave="hoverActive = false"
    >
        <edit-toggle-button
            v-show="portalContentAndDesignStore.liveDesignerEnabled && (isEditing || hoverActive)"
            :isEditing="isEditing"
            @toggle="toggleEdit"
            class="transition-opacity duration-200"
        />
        <template v-if="data && !isEditing">

            <div v-if="data.type === 'text'"
                 v-bind="attrs"
                 :class="[
                     'partnero-page-content-block text-sm',
                     portalContentAndDesignStore.getPageContentTextColorClass,
                 ]"
                 v-html="data.text"
            />

            <input v-if="data.type === 'input' || data.type === 'last_name'"
                type="text"
                ref="inputEl"
                :id="`cfield_${data.id}`"
                :name="`cfields[${data.id}]`"
                 v-model="model.cfields[data.id]"
                :required="data.required"
                :class="portalContentAndDesignStore.getInputStyle"
            />

            <input v-if="data.type === 'portal_signup_last_name' || data.type === 'portal_signup_link_key'"
                type="text"
                ref="inputEl"
                :id="`cfield_${data.id}`"
                :name="`cfields[${data.id}]`"
                v-model="model.cfields[data.id]"
                @input="handleInput($event.target.value, data.type)"
                :required="data.required"
                :class="portalContentAndDesignStore.getInputStyle"
            />

            <select v-if="data.type === 'select' && data.options"
                :id="`cfield_${data.id}`"
                :name="`cfields[${data.id}]`"
                v-model="model.cfields[data.id]"
                :required="data.required"
                :class="portalContentAndDesignStore.getInputStyle"
            >
                <option disabled value="">Select an option</option>
                <template v-for="(label, key) in data.options">
                    <option
                        v-if="label"
                        :key="label + '_' + key"
                        :value="key"
                    >
                        {{ label }}
                    </option>
                </template>
            </select>

            <textarea v-if="data.type === 'textarea'"
                :id="`cfield_${data.id}`"
                :name="`cfields[${data.id}]`"
                v-model="model.cfields[data.id]"
                :required="data.required"
                :class="portalContentAndDesignStore.getInputStyle"
            />

            <div v-if="data.type === 'checkbox' && data.options" class="space-y-2">
                <template v-for="(optionLabel, optionKey) in data.options">
                    <div
                        v-if="optionLabel"
                        :key="optionKey"
                        class="space-x-2 flex text-sm"
                    >
                        <input
                            type="checkbox"
                            :id="`cfield_${data.id}_${optionKey}`"
                            :name="`cfields[${data.id}][${optionKey}]`"
                            :value="optionKey"
                            v-model="model.cfields[data.id]"
                            :class="portalContentAndDesignStore.getCheckboxInputStyle"
                        />
                        <label :for="`cfield_${data.id}_${optionKey}`">{{ optionLabel }}</label>
                    </div>
                </template>
            </div>

            <div v-if="data.type === 'radio' && data.options" class="space-y-2">
                <template v-for="(optionLabel, optionKey) in data.options">
                    <div
                        v-if="optionLabel"
                        :key="optionKey"
                        class="space-x-2 flex text-sm"
                    >
                        <input
                            type="radio"
                            :id="`cfield_${data.id}_${optionKey}`"
                            :name="`signupFormData.cfields[${data.id}]`"
                            :value="optionKey"
                            v-model="model.cfields[data.id]"
                            :class="portalContentAndDesignStore.getCheckboxInputStyle"
                        />
                        <label
                            :for="`cfield_${data.id}_${optionKey}`"
                            :class="portalContentAndDesignStore.getPageContentTextColorClass"
                        >
                            {{ optionLabel }}
                        </label>
                    </div>
                </template>
            </div>

            <select v-if="data.type === 'countries'"
                :id="`cfield_${data.id}`"
                :name="`signupFormData.cfields[${data.id}]`"
                v-model="model.cfields[data.id]"
                class="transition-shadow block w-full rounded border-gray-300 focus:border-gray-400 focus:ring-0 py-2.5 px-3.5 text-sm"
            >
                <option value="">
                    {{ portalContentAndDesignStore.translationSettings.portal_translation_general_select_country ?? 'Select a country ...' }}
                </option>
                <option
                    v-for="country in portalContentAndDesignStore.getCountryOptions"
                    :key="country.value"
                    :value="country.value"
                >
                    {{ country.name }}
                </option>
            </select>

        </template>

        <div v-else class="rounded border border-gray-300 focus:border-gray-400">
            <div class="py-6 px-6 space-y-4" v-if="isEditing">
                <div v-if="data.type !== 'text'">
                    <label
                        class="flex justify-between items-center mb-1.5 text-sm">
                        Label
                        <span class="text-xs text-gray-500" v-if="data.type !== 'text'">Required?</span>
                    </label>
                    <div class="flex relative rounded">
                        <input
                            type="text"
                            name="option1"
                            v-model="data.title"
                            v-bind:class="{ 'pr-10': data.type !== 'text' }"
                            class="block w-full rounded border-gray-300 transition-shadow sm:text-sm focus:border-gray-400 focus:ring-0"/>

                        <button type="button"
                                class="-mt-px absolute right-2 top-3 inline-flex flex-shrink-0 w-7 h-4 rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out cursor-pointer focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-200"
                                role="switch"
                                aria-checked="false"
                                @click="data.required=!data.required"
                                :class="{ 'bg-teal-600': data.required, 'bg-gray-200': !data.required,}"
                                v-if="data.type !== 'text'">
                            <span class="sr-only">Use setting</span>
                            <!-- Enabled: "translate-x-5", Not Enabled: "translate-x-0" -->
                            <span aria-hidden="true"
                                  class="inline-block w-3 h-3 bg-white rounded-full ring-0 shadow transition duration-200 ease-in-out transform pointer-events-none"
                                  :class="{ 'translate-x-3': data.required, 'translate-x-0': !data.required, }"></span>
                        </button>
                    </div>
                </div>

                <div class="grid gap-y-2" v-if="data.type === 'text'">
                    <div
                        class="tiptap-menu"
                        v-if="editor"
                    >
                        <button type="button" @click="editor.chain().focus().toggleBold().run()"
                                :class="{ 'is-active': editor.isActive('bold') }">
                            <svg class="w-5 h-5 text-gray-900" fill="currentColor" xmlns="http://www.w3.org/2000/svg"
                                 viewBox="0 0 24 24" width="24" height="24">
                                <path fill="none" d="M0 0h24v24H0z"/>
                                <path
                                    d="M8 11h4.5a2.5 2.5 0 1 0 0-5H8v5zm10 4.5a4.5 4.5 0 0 1-4.5 4.5H6V4h6.5a4.5 4.5 0 0 1 3.256 7.606A4.498 4.498 0 0 1 18 15.5zM8 13v5h5.5a2.5 2.5 0 1 0 0-5H8z"/>
                            </svg>
                        </button>
                        <button type="button" @click="editor.chain().focus().toggleItalic().run()"
                                :class="{ 'is-active': editor.isActive('italic') }">
                            <svg class="w-5 h-5 text-gray-900" fill="currentColor" xmlns="http://www.w3.org/2000/svg"
                                 viewBox="0 0 24 24" width="24" height="24">
                                <path fill="none" d="M0 0h24v24H0z"/>
                                <path d="M15 20H7v-2h2.927l2.116-12H9V4h8v2h-2.927l-2.116 12H15z"/>
                            </svg>
                        </button>
                        <button type="button" @click="editor.chain().focus().toggleStrike().run()"
                                :class="{ 'is-active': editor.isActive('strike') }">
                            <svg class="w-5 h-5 text-gray-900" fill="currentColor" xmlns="http://www.w3.org/2000/svg"
                                 viewBox="0 0 24 24" width="24" height="24">
                                <path fill="none" d="M0 0h24v24H0z"/>
                                <path d="M13 9h-2V6H5V4h14v2h-6v3zm0 6v5h-2v-5h2zM3 11h18v2H3v-2z"/>
                            </svg>
                        </button>
                        <button type="button" @click="editor.chain().focus().toggleHeading({ level: 1 }).run()"
                                :class="{ 'is-active': editor.isActive('heading', { level: 1 }) }">
                            <svg class="w-5 h-5 text-gray-900" fill="currentColor" xmlns="http://www.w3.org/2000/svg"
                                 viewBox="0 0 24 24" width="24" height="24">
                                <path fill="none" d="M0 0H24V24H0z"/>
                                <path d="M13 20h-2v-7H4v7H2V4h2v7h7V4h2v16zm8-12v12h-2v-9.796l-2 .536V8.67L19.5 8H21z"/>
                            </svg>
                        </button>
                        <button type="button" @click="editor.chain().focus().toggleHeading({ level: 2 }).run()"
                                :class="{ 'is-active': editor.isActive('heading', { level: 2 }) }">
                            <svg class="w-5 h-5 text-gray-900" fill="currentColor" xmlns="http://www.w3.org/2000/svg"
                                 viewBox="0 0 24 24" width="24" height="24">
                                <path fill="none" d="M0 0H24V24H0z"/>
                                <path
                                    d="M4 4v7h7V4h2v16h-2v-7H4v7H2V4h2zm14.5 4c2.071 0 3.75 1.679 3.75 3.75 0 .857-.288 1.648-.772 2.28l-.148.18L18.034 18H22v2h-7v-1.556l4.82-5.546c.268-.307.43-.709.43-1.148 0-.966-.784-1.75-1.75-1.75-.918 0-1.671.707-1.744 1.606l-.006.144h-2C14.75 9.679 16.429 8 18.5 8z"/>
                            </svg>
                        </button>
                        <button type="button" @click="editor.chain().focus().toggleBulletList().run()"
                                :class="{ 'is-active': editor.isActive('bulletList') }">
                            <svg class="w-5 h-5 text-gray-900" fill="currentColor" xmlns="http://www.w3.org/2000/svg"
                                 viewBox="0 0 24 24" width="24" height="24">
                                <path fill="none" d="M0 0h24v24H0z"/>
                                <path
                                    d="M8 4h13v2H8V4zM4.5 6.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm0 7a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm0 6.9a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zM8 11h13v2H8v-2zm0 7h13v2H8v-2z"/>
                            </svg>
                        </button>
                    </div>

                    <div
                        class="block w-full bg-white border px-3.5 py-2 rounded rounded-r border-gray-300 transition-shadow sm:text-sm focus:ring-indigo-100 focus:ring-2 focus:border-indigo-300">
                        <editor-content :editor="editor"/>
                    </div>
                </div>

                <div class="grid gap-y-1.5" v-if="typesWithOptions.includes(data.type)">
                    <label class="block text-sm">
                        Options
                    </label>
                    <div v-for="(option, index) in data.options">
                        <div class="flex relative rounded">
                        <span
                            class="inline-flex items-center px-4 text-gray-500 bg-gray-50 rounded-l border border-r-0 border-gray-300 sm:text-sm">
                            {{ index + 1 }}
                        </span>
                            <input
                                type="text"
                                name="option1"
                                @blur="checkOptions()"
                                @input="checkOptions(option)"
                                v-model="data.options[index]"
                                class="block w-full rounded-r border-gray-300 transition-shadow sm:text-sm focus:ring-0 focus:border-gray-400"/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {
    Editor, EditorContent,
    BubbleMenu,
    FloatingMenu,
} from '@tiptap/vue-3'
import StarterKit from '@tiptap/starter-kit'
import EditToggleButton from "../../Pub/components/EditToggleButton.vue";
import {computed, ref, useAttrs, watch} from "vue";
import {usePortalContentAndDesignStore} from "../../../../stores/partners/portalContentAndDesignStore";
import {useEditableFocus} from "../../../../composables/partners/useEditableFocus";

export default {
    props: {
        modelValue: {
            type: Object,
            required: true
        },
        data: {
            type: Object,
            required: true
        }
    },

    emits: ['update:modelValue'],

    components: {
        EditToggleButton,
        EditorContent,
        BubbleMenu,
        FloatingMenu,
    },
    setup(props) {
        const portalContentAndDesignStore = usePortalContentAndDesignStore();

        const isEditing = ref(false);
        const hoverActive = ref(false);
        const inputEl = ref(null);

        useEditableFocus(isEditing, inputEl)

        const attrs = useAttrs();

        const model = computed({
            get: () => props.modelValue,
            set: (val) => emit('update:modelValue', val)
        });

        const toggleEdit = () => {
            isEditing.value = !isEditing.value
            if (!isEditing.value) {
                hoverActive.value = false
            }
        }

        return {
            portalContentAndDesignStore,
            isEditing,
            hoverActive,
            attrs,
            model,
            toggleEdit
        }
    },
    data() {
        return {
            editor: null,
            typesWithOptions: ['select', 'checkbox', 'radio']
        }
    },

    methods: {
        checkOptions(optionFocused) {
            if (!this.typesWithOptions.includes(this.data.type)) {
                return;
            }

            this.data.options ??= [];
            this.data.options = this.data.options.filter((element, index, options) => {
                if (element === optionFocused) {
                    return true;
                }

                return !!options[index];
            })

            if (!this.data.options.length || this.data.options[this.data.options.length - 1]) {
                this.data.options.push('');
            }
        },
        handleInput(value, type) {
            if (type === 'portal_signup_link_key') {
                this.portalContentAndDesignStore.signupFormData.key = value;
            } else if (type === 'portal_signup_last_name') {
                this.portalContentAndDesignStore.signupFormData.last_name = value;
            }
        }
    },

    mounted() {
        this.checkOptions();
        this.editor = new Editor({
            content: this.data.text,
            onUpdate: () => {
                this.data.text = this.editor.getHTML()
            },
            extensions: [
                StarterKit,
            ],
        })
    },

    beforeUnmount() {
        this.editor.destroy();
    },
}
</script>

<style lang="scss">
/* Basic editor styles */

.ProseMirror {
    min-height: 70px;

    > * + * {
        margin-top: 0.75em;
    }

    ul,
    ol {
        padding: 0 1rem;
    }

    blockquote {
        padding-left: 1rem;
        border-left: 2px solid rgba(#0D0D0D, 0.1);
    }

    &:focus, &:active {
        outline: none;
    }

    h1 {
        font-weight: bold;
        font-size: 32px;
        line-height: 1.1;
    }

    h2 {
        font-weight: bold;
        font-size: 24px;
        line-height: 1.1;
    }
}

.tiptap-menu {
    display: flex;
    //background-color: #111827;
    //padding: 0.4rem .5rem;
    //border-radius: 0.2rem;

    button {
        border: none;
        background: none;
        color: #FFF;
        font-size: 0.85rem;
        font-weight: 500;
        padding: 0 0.4rem;
        opacity: 0.6;

        &:focus, &:active {
            outline: none;
        }

        &:hover,
        &.is-active {
            opacity: 1;
        }
    }
}

.floating-menu {
    display: flex;
    background-color: #111827;
    padding: 0.2rem;
    border-radius: 0.5rem;

    button {
        border: none;
        background: none;
        font-size: 0.85rem;
        font-weight: 500;
        padding: 0 0.2rem;
        opacity: 0.6;

        &:hover,
        &.is-active {
            opacity: 1;
        }
    }
}
</style>

